<div class="button-container">
    <div class="row my-2">
        <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
            <p class="title mb-0">Cadastro realizado com sucesso</p>
        </div>
    </div>

    <div class="row my-2">
        <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
            <p class="subtitle">Volte ao inicio para realizar o login</p>
        </div>
    </div>

    <div class="row button-container">
        <div class="col-12 d-flex justify-content-center">
            <button (click)="redirectToLogin()" type="button" class="button">
                <span>Voltar ao início</span>
            </button>
        </div>
    </div>
</div>